import React, { useCallback } from 'react';
import SelectV2 from 'components/Select/SelectV2';
import _ from 'lodash';
import { TimeOffsetTranslation } from '../../services/constants';
import PropTypes from 'prop-types';

const timeOffsetValues = _.map(TimeOffsetTranslation, (text, value) => ({ text, value }));

/**
 *
 * @param value In format { offset: TimeOffset, from: <Date>, to: <Date> } where from and to is valid only if offset == TimeOffset.CUSTOM
 * @param onChange Changed value
 * @returns {JSX.Element}
 * @constructor
 */
const TimeRangeSelector = ({ value, onChange }) => {
  const timeOffsetChanged = useCallback(offset => {
    onChange({ offset });
  }, [onChange]);

  // TODO: Handle TimeOffset.CUSTOM
  return (
    <SelectV2
      value={value?.offset}
      options={timeOffsetValues}
      onChange={timeOffsetChanged} />
  );
};

TimeRangeSelector.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired
};

export default React.memo(TimeRangeSelector);
